import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { antes, despues } from '../data/content';
export function Comparison() {
  return <section aria-labelledby="comparativa" className="w-full bg-ink-raised" data-id="element-29" data-mp="1g8ud0y5t1pn7">
      <div className="mx-auto max-w-content px-5 py-10 sm:py-16 lg:py-24" data-id="element-30" data-mp="1l6cpuzmy0p0h">
        <h2 id="comparativa" className="text-center font-display text-3xl text-cream sm:text-4xl" data-id="element-31" data-mp="1pynrc6xc0iv5">
          Antes y después de Memorias del Alma™
        </h2>

        <div className="mt-7 grid gap-4 sm:mt-12 sm:gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-32" data-mp="1uzbe2gej2djk">
          <div className="flex h-full flex-col rounded-2xl border border-line bg-ink p-7 lg:p-9" data-id="element-33" data-mp="1zugzle40pq74">
            <p className="font-display text-2xl text-cream/70" data-id="element-34" data-mp="23yor1j1v1k91">Antes de Memorias del Alma™</p>
            <p className="mt-2 text-[13px] uppercase tracking-[0.14em] text-muted" data-id="element-35" data-mp="28wgiyd2i96d8">
              El costo de la improvisación en sesión
            </p>
            <ul className="mt-7 flex-1 space-y-5" data-id="element-36" data-mp="eipf5u6uxgpp">
              {antes.map(item => <li key={item} className="flex gap-3.5" data-id="element-37" data-mp="eksc6y6fga3x">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-line text-muted" aria-hidden="true" data-id="element-38" data-mp="1m1imdlz4kn1w">
                    <XIcon className="h-3 w-3" data-id="element-39" data-mp="1d8f3gy5pnhzv" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-muted" data-id="element-40" data-mp="1d6azkg7taizl">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-amethyst/45 bg-[#170E28] p-7 lg:p-9" data-id="element-41" data-mp="2503ar69mtebu">
            <p className="font-display text-2xl text-gold" data-id="element-42" data-mp="20xq66l6mfmgn">Con Memorias del Alma™</p>
            <p className="mt-2 text-[13px] uppercase tracking-[0.14em] text-amethyst" data-id="element-43" data-mp="1vydixzbu8ddj">
              El sistema definitivo para el terapeuta
            </p>
            <ul className="mt-7 flex-1 space-y-5" data-id="element-44" data-mp="1r1wjwa33oelo">
              {despues.map(item => <li key={item} className="flex gap-3.5" data-id="element-45" data-mp="kkj4tnwkzg0g">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amethyst-deep text-cream" aria-hidden="true" data-id="element-46" data-mp="fkwtjk0bc9ua">
                    <CheckIcon className="h-3 w-3" data-id="element-47" data-mp="h2c1ovgestmv" />
                  </span>
                  <span className="text-[15px] leading-relaxed text-cream/90" data-id="element-48" data-mp="lzua8kqil6uc">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}